<template>
  <div class="listing-form overview-information margin-auto">
    <Card class="overview-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-apps"/>
        <div><p style="color:#000;font-weight:bold">Overview</p></div>
      </div>
      <div>
        <Form ref="OverviewInformationForm" :model="value" :rules="formRules" label-position="top">
          <FormItem prop="description">
            <span slot="label">
              <span style="color:#ed4014;font-family:SimSun;margin-right:4px;line-height:1;">*</span>
              Company overview
            </span>
            <TinyEditor v-model="value.description"/>
          </FormItem>
          <FormItem label="Solutions? Products? Problems you can solve?" prop="solutions_to_problems">
            <TinyEditor v-model="value.solutions_to_problems"/>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import TinyEditor from '@/components/ui/TinyEditor'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    TinyEditor
  },

  data () {
    const validateDescription = (rule, value, callback) => {
      if (value === null || value === '') {
        callback(new Error('Please enter your company description'))
      } else {
        callback()
      }
    }
    return {
      formRules: {
        description: [
          { validator: validateDescription, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleSubmit () {
      this.$refs.OverviewInformationForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.overview-information {
  max-width:700px;
  .overview-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.overview-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
